module.exports = __webpack_public_path__ + "static/media/arrow-up-blue.f0260126.svg";